<template>
    <div class="container">
    <div class="box-auth">
        <div class="box-forgot-pass">
            <!--<h3 class="auth-box-title mb-20">Create new account </h3>-->

            <template v-if="screen == 1">
                <div class="forgot-popup-header">
                    <h3 class="auth-box-title">{{$t('forgot_password')}}</h3>
                    <a href="/login">
                        <img class="icon-closed" src="/themes/ito/images/icon-closed.svg" alt=""> 
                    </a>
                </div>
                <div class="forgot-popup-content">
                    <div class="form-group">
                        <label class="lisa-label-input">{{$t('username')}}</label>
                        <input type="text" class="lisa-input input-full-width" name="username" :placeholder="$t('enter_your_username')" v-model="user_name" autocomplete="off">
                    </div>
                    <div class="error-message text-left mb-12" v-if="errors.user_name">{{ $t(`${errors.user_name}`) }}</div>
                    <div class="forgot-id-link">
                        <a @click="forgetID">{{$t('lisa_web_forgot_id')}}</a>
                    </div>
                    <a href="#" class="support-link-bottom">{{$t('need_support')}} <strong style="font-weight:700">1900 088 893</strong></a>
                </div>

                <div class="forgot-popup-footer">
                    <div class="form-group d-flex justify-content-center">
                        <a class="lisa-btn-small" href="/login">{{$t('cancel')}}</a>
                        <div class="lisa-btn-small" :class="user_name != ''?'lisa-btn-small active':'lisa-btn-small'"
                             @click="user_name != ''?getAccount():''">{{$t('next')}}</div>
                    </div>
                </div>
            </template>
            <template v-if="screen == 2">
                <div class="forgot-popup-header">
                    <h3 class="auth-box-title">{{$t('forgot_password')}}</h3>
                    <a href="/login">
                        <img class="icon-closed" src="/themes/ito/images/icon-closed.svg" alt=""> 
                    </a>
                    <img class="register-back" src="/themes/web/assets/images/icon-calender-prev.svg"
                             @click="changeScreen(1)"/>
                </div>
                <div class="forgot-popup-content">
                    <p>{{$t('account')}} <b class="txt-blue">{{user_name ? user_name: ''}}</b> </p>
                    <p>Email: <span class="txt-blue"><b>{{email ? hideEmail(email): ''}}</b></span></p>
                    <p>{{$t('phone')}} <span class="txt-blue"><b>{{phone ? hidePhone(phone): ''}}</b></span></p>
                    <br/>
                    <div class="form-group">
                        <p>{{$t('select_validate_method')}}</p>
                        <br/>
                        <div class="d-flex align-items-center">
                            <input class="mr-12" type="radio" id="email" name="fav_language" value=0 v-model="type">
                            <label for="email">Email</label><br>
                        </div>
                        <div class="form-group" v-if="type == 0 && type != ''">
                            <!--<label class="lisa-label-input">Email</label>-->
                            <input type="text" class="lisa-input input-full-width show-forgot"
                                   :class="errors.email ? 'has-err': ''" name="re_email"
                                   :placeholder="$t('re_enter_email')" v-model="re_email"
                                   autocomplete="off">
                            <div class="error-message text-left" style="margin-top:12px" v-if="errors.email">{{ $t(`${errors.email}`)  }}</div>
                        </div>
                        <br/>
                        <div class="d-flex align-items-center">
                            <input class="mr-12" type="radio" id="phone" name="fav_language" value=1 v-model="type">
                            <label for="phone">{{$t('phone')}}</label><br>
                        </div>
                        <div class="show-forgot" v-if="type == 1 && type != ''">
                            <!-- {{$t('please_use_the_registered_phone_number_to_text_with_the_syntax')}}:
                            <span class="txt-blue"><b>{{$t('syntax')}}</b></span> {{$t('send_to_number')}} <span class="txt-blue"><b>1900 088 893</b></span> để lấy mã OTP.<br/>
                            {{$t('')}} <span class="txt-blue"><b>1000vnd</b></span> -->
                            <span v-html="$t('p_mapping_child_text06')"></span>
                        </div>
                        <br/>
                    </div>
                    <a href="#" class="support-link-bottom">{{$t('need_support')}} 1900 088 893</a>
                </div>
                <div class="forgot-popup-footer">
                    <div class="form-group d-flex justify-content-center">
                        <a class="lisa-btn-small" href="/login">{{$t('cancel')}}</a>
                        <div class="lisa-btn-small"
                             :class="(type !== '' && email !== '' && re_email != '')?'lisa-btn-small active':'lisa-btn-small'"
                             @click="(type !== '' && email !== '' && re_email != '')?getOtp():''">{{$t('next')}}
                        </div>
                    </div>
                </div>
            </template>
            <template v-if="screen == 3">
                <div class="forgot-popup-header">
                    <h3 class="auth-box-title">Forgot password</h3>
                    <a href="/login">
                        <img class="icon-closed" src="/themes/ito/images/icon-closed.svg" alt=""> 
                    </a>
                    <!-- <img class="register-back" src="/themes/web/assets/images/icon-calender-prev.svg"
                             @click="changeScreen(1)"/> -->
                </div>
                <div class="forgot-popup-content">
                    <p>{{$t("Hệ thống đã gửi mã OTP vào email")}} <b class="txt-blue">{{email}}</b>
                        {{$t("check_email_repass")}}</p>
                    <div class="form-group">
                        <label class="lisa-label-input"> {{$t("OTP_code")}}</label>
                        <input type="text" class="lisa-input input-full-width" name="otp" placeholder="Nhập mã OTP" v-model="otp" autocomplete="off">
                    </div>
                    <a href="#" class="support-link-bottom">{{$t('need_support')}} 1900 088 893</a>
                </div>
                <div class="forgot-popup-footer">
                    <div class="form-group d-flex justify-content-center">
                        <a class="lisa-btn-small" href="/login">{{$t("cancel")}}</a>
                        <div class="lisa-btn-small" :class="otp !== ''?'lisa-btn-small active':'lisa-btn-small'"
                             @click="otp !== ''?confirmOTP():''">{{$t("next")}}</div>
                    </div>
                </div>
            </template>
            <template v-if="screen == 4">
                <div class="forgot-popup-header">
                    <h3 class="auth-box-title">Forgot password</h3>
                    <a href="/login">
                        <img class="icon-closed" src="/themes/ito/images/icon-closed.svg" alt=""> 
                    </a>
                    <!-- <img class="register-back" src="/themes/web/assets/images/icon-calender-prev.svg"
                             @click="changeScreen(1)"/> -->
                </div>
                <div class="forgot-popup-content">
                    <p>{{$t("please_change_your_password_before_login")}}</p>
                    <div class="form-group">
                        <label class="lisa-label-input"> {{$t('new_password')}}</label>
                        <input type="password" class="lisa-input input-full-width" name="password" placeholder="Nhập mật khẩu mới" v-model="password" autocomplete="off">
                    </div>
                    <div class="form-group">
                        <label class="lisa-label-input">{{$t('need_support')}}{{$t('confirm_new_password')}}</label>
                        <input type="password" class="lisa-input input-full-width" name="cf_password" placeholder="Nhập lại mật khẩu mới" v-model="cf_password" autocomplete="off">
                    </div>
                    <a href="#" class="support-link-bottom">{{$t('need_support')}} 1900 088 893</a>
                </div>
                <div class="forgot-popup-footer">
                    <div class="form-group d-flex justify-content-center">
                        <a class="lisa-btn-small" href="/login">{{$t('cancel')}}</a>
                        <div class="lisa-btn-small" :class="(password !== '' && cf_password !== '')?'lisa-btn-small active':'lisa-btn-small'"
                             @click="(password !== '' && cf_password !== '')?resetNewPassword():''">{{$t('next')}}</div>
                    </div>
                </div>
            </template>
            <template v-if="screen == 11">
                <div class="forgot-popup-header">
                    <h3 class="auth-box-title">{{$t("forgot_password")}}</h3>
                    <a href="/login">
                        <img class="icon-closed" src="/themes/ito/images/icon-closed.svg" alt=""> 
                    </a>
                    <!-- <img class="register-back" src="/themes/web/assets/images/icon-calender-prev.svg"
                             @click="changeScreen(1)"/> -->
                </div>
                <div class="forgot-popup-content">
                    <div class="form-group">
                        <label class="lisa-label-input">{{$t("full_name")}}</label>
                        <input type="text" class="lisa-input input-full-width" name="fullname" placeholder="Nhập vào họ và tên của bạn" v-model="fullname" autocomplete="off" >
                    </div>
                    <div class="form-group" style="position:relative">
                        <label class="lisa-label-input">{{$t("date_of_birth")}}</label>
                        <input type="text" class="lisa-input input-full-width date datepicker birthday" name="birthday" autocomplete="off" placeholder="dd/mm/yyyy" v-model="birthday">
                        <img class="icon-birthday" src="/themes/ito/images/icon-birthday.svg">
                    </div>
                    <div class="error-message text-left mb-12">{{ $t(error_1) }}</div>
                    <a href="#" class="support-link-bottom">{{$t('need_support')}} 1900 088 893</a>
                </div>

                <div class="forgot-popup-footer">
                    <div class="form-group d-flex justify-content-center">
                        <a class="lisa-btn-small" href="/login">{{$t('cancel')}}</a>
                        <div class="lisa-btn-small" :class="(fullname != '' && birthday != '')?'lisa-btn-small active':'lisa-btn-small'"
                             @click="(fullname != '' && birthday != '')?getListForgetAcc():''">{{$t('next')}}</div>
                    </div>
                </div>
            </template>
            <template v-if="screen == 12 ">
                <div class="forgot-popup-header">
                    <h3 class="auth-box-title">{{$t("forgot_password")}}</h3>
                    <a href="/login">
                        <img class="icon-closed" src="/themes/ito/images/icon-closed.svg" alt=""> 
                    </a>
                    <!-- <img class="register-back" src="/themes/web/assets/images/icon-calender-prev.svg"
                             @click="changeScreen(1)"/> -->
                </div>
                <div class="forgot-popup-content">
                    <p>{{$t("lisa_web_system_find")}} <b class="txt-blue">{{list_accounts? list_accounts.length:'0'}}</b> {{$t("student")}}</p>
                    <template>
                        <div class="account-item" v-for="(acc, index) in list_accounts">
                            <input type="radio" :id="'account_'+index" name="radio" :value="index" v-model="account">
                            <label :for="'account_'+index">
                                <div>{{fullname}} ({{birthday}})</div>
                                <div>Email: <b class="txt-blue">{{hideEmail(acc.email)}}</b></div>
                                <div>{{$t("phone")}}: <b class="txt-blue">{{acc.phone? hidePhone(acc.phone):''}}</b></div>
                            </label>
                        </div>
                    </template>
                    <a href="#" class="support-link-bottom">{{$t('need_support')}} 1900 088 893</a>
                </div>
                <div class="forgot-popup-footer">
                    <div class="form-group d-flex justify-content-center">
                        <a class="lisa-btn-small" href="/login">{{$t('cancel')}}</a>
                        <div class="lisa-btn-small" :class="account !== ''?'lisa-btn-small active':'lisa-btn-small'"
                             @click="account !== ''?listAccoutToForgot():''">{{$t('next')}}</div>
                    </div>
                </div>
            </template>
        </div>
    </div>
    <div class="container">
        <div id="resetPassSuccess" class="modal fade" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document" data-backdrop="static" data-keyboard=false>
                <div class="modal-content">
                    <div class="modal-success" style="color: #000">
                        <h4 class="title">{{$t('password_has_been_updated_successfully')}}</h4>

                        <!--<img src="/themes/ito/images/get-rewarded.svg" alt="">-->
                        <p>{{$t('a_new_password_has_been_sent_to_email_address')}} {{email}}</p>
                        <p>{{$t('please_check_your_email_to_get_the_password')}}</p>

                        <div class="d-flex justify-content-center">
                            <a class="lisa-btn active"
                                href="/login">
                                OK
                            </a>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>

</template>

<script>
    import {
        getForgetAccount,
        getListForgetAccount,
        confirmForget,
        confirmOtp,
        resetPassword
    } from '../../models/auth'
    import axios from "axios";
    import {showDialog} from '../../utils/dialog'
    import {mapGetters} from 'vuex'

    export default {
        name: "ForgotPassword",
        data() {
            return this.initState();
        },

        created() {
            this.fetch()
        },
        mounted() {
            // $('#ForgotPopup').modal('show');
        },
        methods: {
            initState() {
                return {
                    errors: {
                        user_name: '',
                        email: ''
                    },
                    error_1: '',
                    user_name: '',
                    user_id: '',
                    phone: '',
                    email: '',
                    re_email: '',
                    fullname: '',
                    birthday: '',
                    otp: '',
                    password: '',
                    cf_password: '',
                    screen: 1,
                    list_accounts: [],
                    type: '',
                    account: ''
                };
            },
            fetch() {
            },
            forgetID() {
                this.user_name = '';
                this.user_id = '';
                this.fullname = '';
                this.phone = '';
                this.email = '';
                this.screen = 11;
                this.$nextTick(function () {
                    //initDatepicker();

                    $('.birthday').datepicker({
                        dateFormat: 'dd/mm/yy',
                        changeMonth: true,
                        changeYear: true,
                        showOtherMonths: true,
                        selectOtherMonths: false,
                        yearRange: '1900:+0',
                        monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
                    }).on('change', (e) => {
                        this.searchDate(e);
                    });
                })
            },
            async getAccount(){
                const that = this;
                that.isLoading = true;
                that.errors.user_name = '';
                const params = {
                    username: that.user_name,
                };
                await axios.all([
                    getForgetAccount(params),
                ]).then(axios.spread((user_response) => {
                    that.isLoading = false;
                    if (user_response.data.code == 0) {
                        if (user_response.data.results) {
                            that.user_id = user_response.data.results.id;
                            that.email = user_response.data.results.email;
                            that.phone = user_response.data.results.phone;
                            that.changeScreen(2);
                        } else {
                            that.errors.user_name = "not_found_username";
                        }
                    } else {
                        that.errors.user_name = "not_found_username";
                    }
                }));
            },
            getListForgetAcc(){
                const that = this;
                const params = {
                    fullname: that.fullname,
                    birthday: moment(that.birthday, 'DD/MM/YYYY').format('YYYY-MM-DD')
                };
                that.$store.commit("setLoading", true);

                getListForgetAccount(params).then((response) => {
                    that.$store.commit("setLoading", false);

                    if (response.data.code != 0) {
                        that.error_1 = "not_found_username"
                        return;
                    }
                    // alert('Ok')
                    that.list_accounts = response.data.results.account || [];
                    that.changeScreen(12)
                }).catch((response) => {
                    that.$store.commit("setLoading", false);
                    console.error(response)
                });
            },
            listAccoutToForgot(){
                this.user_name = this.list_accounts[this.account].username;
                this.email = this.list_accounts[this.account].email;
                this.phone = this.list_accounts[this.account].phone;
                this.fullname = this.list_accounts[this.account].fullname;
                this.re_email = '';
                this.changeScreen(2);
            },
            getOtp(){
                const that = this;
                if (that.re_email != that.email) {
                    that.errors.email = 'not_match_email';
                    return false;
                }
                that.errors.email = '';
                const formData = new FormData();

                formData.append('username', that.user_name);
                formData.append('type', that.type);
                formData.append('email', that.type == 0 ? that.email : '');
                formData.append('phone', that.type == 1 ? that.phone : '');

                that.$store.commit("setLoading", true);

                confirmForget(formData).then((response) => {
                    that.$store.commit("setLoading", false);

                    if (response.data.code != 0) {
                        alert(response.data.msg)

                        return;
                    }
                    // alert('Ok')
                    // that.changeScreen(3)
                    $('#resetPassSuccess').modal('show');
                }).catch((response) => {
                    that.$store.commit("setLoading", false);
                    console.error(response)
                });
            },
            confirmOTP(){
                const that = this;
                const formData = new FormData();

                formData.append('username', that.user_name);
                formData.append('code', that.otp);

                that.$store.commit("setLoading", true);

                confirmOtp(formData).then((response) => {
                    that.$store.commit("setLoading", false);

                    if (response.data.code != 0) {
                        alert(response.data.msg)

                        return;
                    }
                    alert('Ok');
                    that.changeScreen(4)
                }).catch((response) => {
                    that.$store.commit("setLoading", false);
                    console.error(response)
                });
            },
            resetNewPassword(){
                const that = this;
                const formData = new FormData();

                formData.append('username', that.user_name)
                formData.append('new_pass', that.password);
                formData.append('confirm_pass', that.cf_password);

                that.$store.commit("setLoading", true);

                resetPassword(formData).then((response) => {
                    that.$store.commit("setLoading", false);

                    if (response.data.code != 0) {
                        alert(response.data.msg)

                        return;
                    }
                    alert('Ok');
                    // $('#ForgotPopup').modal('hide');
                    $('#resetPassSuccess').modal('show');
                    // that.changeScreen(4)
                }).catch((response) => {
                    that.$store.commit("setLoading", false);
                    console.error(response)
                });
            },
            searchDate({target}){
                this.birthday = target.value;
            },
            searchEvent({target}) {
                this.user[target.name] = target.value;
            },
            changeScreen($screen) {
                this.screen = $screen;
            },
            isNumeric(value) {
                return /^\d+$/.test(value);
            },
            validateEmail(value) {
                let is_valid = false;
                if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
                    is_valid = true;
                }
                return is_valid;
            },
            hideEmail(email) {
                if (email == '') {
                    return ''
                }
                let hide = email.split("@")[1].length - 5;
                let r = new RegExp(".{" + hide + "}@", "g");
                return email.replace(r, "****@");
            },
            hidePhone(phone) {
                if (phone == '') {
                    return ''
                }
                return phone.replace(/(\d{2})(.*)(\d{3})/, '$1*****$3')
            }
        }
    }
</script>

<style scoped>
    .forgot-popup {
        width: 550px;
        max-width: 550px;
    }

    .forgot-popup .modal-content {
        position: relative;
        height: 470px;
        padding: 0px;
    }

    .forgot-popup-header {
        position: relative;
        border-bottom: 1px solid #E5E5E5;
        padding: 20px 0 18px;
        height: 73px;
    }

    .forgot-popup-content {
        position: relative;
        height: 320px;
        padding: 20px 50px;
    }

    .forgot-popup-footer {
        border-top: 1px solid #E5E5E5;
        padding: 20px 0;
    }

    .popup-title {
        margin-bottom: 0;
    }

    .input-full-width {
        width: 100%;
    }

    .forgot-popup-footer .ito-btn-small {
        margin: 0 10px;
    }

    .support-link-bottom {
        position: absolute;
        bottom: 10px;
        left: 0;
        right: 0;
        display: block;
        margin: 0 auto;
        text-align: center;
        font-size: 14px;
        font-weight: 700;
    }

    .forgot-id-link {
        font-size: 14px;
        font-weight: 400;
        text-decoration: underline;
        color: #1F9FFC;
        cursor: pointer;
    }

    .forgot-popup-content p {
        font-size: 14px;
        margin-bottom: 5px;
    }

    label {
        font-size: 14px;
        font-weight: 400;
    }

    .txt-blue {
        color: #1F9FFC;
    }
    .account-item{
        margin: 6px 0px;
        display: flex;
        align-items: center;
    }
    .account-item input{
        margin-right: 15px;
    }
    .account-item label{
        margin-bottom: 0;
    }
    .modal-success{
        text-align: center;
    }
    .modal-success .title{
        font-size: 24px;
        text-align: center;
        font-weight: 700;
    }
    .modal-success h6{
        margin: 15px 0px;
        font-size: 14px;
        line-height: 19px;
    }
    
    .box-forgot-pass{
        width: 550px;
        height: 470px;
    }
    .forgot-popup-content .lisa-label-input{
        font-weight: 700;
        font-size: 12px;
        margin-bottom: 2px;
    }
    .support-link-bottom{
        color: #1F9FFC;
    }
    .error-message{
        font-size: 14px;
        color: #E84343;
    }
    .icon-closed{
        position: absolute;
        right: 10px;
        top: 10px;
    }
    .register-back{
        position: absolute;
        top: 25px;
        cursor: pointer;
        /* left: 28px;
        top: 30px; */
    }
    .forgot-popup-content p{
        font-size: 12px;
    }
    .show-forgot{
        font-size: 14px;
        margin-top: 12px;
        margin-bottom: 0;
    }
    #resetPassSuccess .modal-content{
        width: 520px;
        height: 203px;
        padding: 20px 56px;
    }
    #resetPassSuccess .title{
        font-size: 20px;
        color: #1B1B1B;
        margin-bottom: 28px;
    }
    #resetPassSuccess p{
        font-size: 12px;
    }
    #resetPassSuccess p:nth-child(3){
        margin-bottom: 0;
    }
    #resetPassSuccess .lisa-btn{
        margin-top: 25px;
        height: 35px;
        display: flex;
        align-items: center;
        width: fit-content;
        line-height: 35px;
    }
    #resetPassSuccess .lisa-btn:hover{
        color: #fff;
    }
    .icon-birthday{
        position: absolute;
        top: 33px;
        right: 13px;
    }
    .modal-dialog{
        /* margin: 0 !important; */
        display: flex !important;
        justify-content: center !important;
    }
    .lisa-btn-small:hover{
        color: #fff;
    }

</style>
